import { useTypeDefinition } from './type-definition-context';

/** Renders a type definition of function arguments or object properties with syntax highlighting. */
export const TypeDefinitionKey = () => {
  const {
    entity,
    language,
    syntax
  } = useTypeDefinition();
  const {
    key,
    optional
  } = entity;
  let optionalSymbol: React.ReactNode = null;
  if (optional) {
    optionalSymbol = <span className="token operator">?</span>;
  }
  if (language === 'js' || language === 'json' || language === 'curl') {
    return <>
        {key}
        {optionalSymbol}
        <span className="token operator">:</span>
      </>;
  }
  if (language === 'ruby') {
    return <>
        {syntax === 'list' && optionalSymbol}
        {key}
        <span className="token operator">:</span>
      </>;
  }
  if (language === 'python') {
    if (syntax === 'object') {
      return <>
          <span className="token string">"{key}"</span>
          <span className="token operator">:</span>
        </>;
    }
    return <>
        <span className="token">{key}</span>
        <span className="token operator">:</span>
      </>;
  }

  // "object" syntax is for associative arrays for PHP
  if (language === 'php') {
    if (syntax === 'object') {
      return <span className="token string">"{key}"</span>;
    }
    return <span className="token">${key}</span>;
  }
  if (language === 'go') {
    if (syntax === 'map') {
      return <>
          "{key}"{optionalSymbol}
        </>;
    }
    return <>
        {key}
        {optionalSymbol}
      </>;
  }
  return <span className="token" data-sentry-component="TypeDefinitionKey" data-sentry-source-file="type-definition-key.tsx">{key}</span>;
};